<template>
  <div>

    <!-- 审核中 开始 -->
    <div class="in-check"
         v-if="checkShow">
      <i class="iconfont icon-sp_shenhezhong"></i>
      <p>审核中</p>
      <p>发布成功，正在审核，请耐心等待...</p>
      <el-button @click="checkShow=false">确定</el-button>
    </div>
    <!-- 审核中 结束 -->
  </div>
</template>
<script>
export default {
  name: 'filecheck',
  data() {
    return {
      checkShow: true
    }
  }
}
</script>
<style lang="scss">
.in-check {
  width: 398px;
  border-radius: 2px;
  position: absolute;
  background: #fff;
  top: 20%;
  left: 25%;
  padding: 30px 0;

  i {
    font-size: 50px;
    color: rgb(255, 162, 0);
  }

  p:nth-child(2) {
    color: #003580;
    font-family: "Microsoft YaHei-Bold";
    font-size: 18px;
  }

  p:nth-child(3) {
    margin-top: 10px;
    font-size: 14px;
    color: #333;
  }

  .el-button {
    width: 148px;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    color: #fff;
    background: #2d61a8;
    border-radius: 2px;
    margin-top: 30px;
    padding: 0;
    border: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mind/fileCheck.vue